import { X } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import type { HistoryChip } from './historyChips';

/** Aktive Filter als Chips mit ✕ und „Alle Filter zurücksetzen“ (Board „Verlauf“). */
export function HistoryChipsRow({
  chips,
  pendingTechnicalId = false,
  onRemove,
  onClear,
}: {
  chips: HistoryChip[];
  /** Eine halbe technische ID steht im geschlossenen Panel; sie wirkt nicht. */
  pendingTechnicalId?: boolean;
  onRemove: (chip: HistoryChip) => void;
  onClear: () => void;
}) {
  if (chips.length === 0 && !pendingTechnicalId) return null;
  return (
    <div className="border-paper flex flex-wrap items-center gap-1.5 border-b px-3 py-2.5 md:px-[18px]">
      {chips.map((chip) => (
        <button
          key={chip.label}
          type="button"
          aria-label={`Filter entfernen: ${chip.label}`}
          title={chip.onlyIn && `Wirkt nur in der Ansicht ${chip.onlyIn}`}
          onClick={() => onRemove(chip)}
          className={cn(
            'rounded-pill flex min-h-11 items-center gap-1.5 px-2.5 text-xs font-bold md:min-h-[30px]',
            chip.onlyIn ? 'bg-card-alt text-ink-soft' : 'bg-forest-soft text-forest-deep',
          )}
        >
          {chip.label}
          {chip.onlyIn && <span className="font-semibold">(nur {chip.onlyIn})</span>}
          <X size={12} aria-hidden />
        </button>
      ))}
      {pendingTechnicalId && (
        <span
          role="status"
          className="rounded-pill bg-amber-tint text-amber-ink flex min-h-11 items-center px-2.5 text-xs font-bold md:min-h-[30px]"
        >
          Technische ID unvollständig – wirkt noch nicht
        </span>
      )}
      <button
        type="button"
        onClick={onClear}
        className="text-ink-soft min-h-11 px-1.5 text-xs font-bold md:min-h-[30px]"
      >
        Alle Filter zurücksetzen
      </button>
    </div>
  );
}
